import { createContext, useContext, ReactNode } from "react";

const ClientViewContext = createContext<boolean>(false);

export function ClientViewProvider({ children, value }: { children: ReactNode; value: boolean }) {
  return (
    <ClientViewContext.Provider value={value}>
      {children}
    </ClientViewContext.Provider>
  );
}

export function useClientViewContext() {
  return useContext(ClientViewContext);
}
